<div class="grid-wrapper flex-col" [class.grid-wrapper-disabled]="disabled">
  <ag-grid-angular #grid
    [class]="'flex-item-fill ag-theme-' + getTheme()"
    [rowData]="_data?.rows"
    [treeData]="isTree"
    [getDataPath]="getDataPath"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [groupDefaultExpanded]=-1
    [pinnedBottomRowData]="internalPinnedBottomRows"
    [columnDefs]="colDefs"
    [animateRows]=false
    [getRowId]="_data?.useRowIds ? getRowId : undefined"
    [context]="context"
    [gridOptions]="gridOptions"
    [localeText]="_SmTable2Component.locale"
    [rowSelection]="{ mode: multiSelection ? 'multiRow' : 'singleRow', checkboxes: _checkBoxSelection, enableClickSelection: !_checkBoxSelection }"
    [selectionColumnDef]="{ width: 40, maxWidth: 40, pinned: 'left' }"
    [getRowClass]="getRowClass"
    [autoSizeStrategy]="horizontalScroll ? undefined : autoSizeStrategy"
    [components]="components"
    [enableCellTextSelection]="allowCellTextSelection"
    [domLayout]="autoHeight ? 'autoHeight' : undefined"
    [tooltipShowDelay]=500
    [suppressCellFocus]=true
    [rowDragManaged]="_allowRowDrag && rowDragManaged"
    [rowDragText]="getRowDragText"
    [getRowHeight]="getRowHeight"
    [tabToNextCell]="tabForSameRow ? tabToNextCellBound : undefined"
    overlayLoadingTemplate="<span></span>"
    (cellKeyDown)="cellKeyDown($event)"
    (cellMouseOver)="cellMouseOver($event)"
    (cellMouseOut)="cellMouseOut($event)"
    (cellClicked)="cellClicked($event)"
    (rowDoubleClicked)="rowDoubleClicked($event)"
    (cellEditingStarted)="cellEditingStarted($event)"
    (cellEditingStopped)="cellEditingStopped($event)"
    (cellContextMenu)="cellContextMenu($event)"
    (contextmenu)="gridContextMenu($event)"
    (cellFocused)="cellFocused($event)"
    (rowSelected)="rowSelected($event)"
    (rowDragEnd)="rowDragEnd($event)"
    (rowDragMove)="rowDragMove($event)"
    (selectionChanged)="selectionChanged($event)"
    (cellValueChanged)="cellValueChanged($event)"
    (sortChanged)="sortChanged($event)"
    (gridReady)="gridReady($event)"
    (filterChanged)="filterChanged($event)"
    [rowNumbers]="isEnterprise && displayRowNumbers"
    [sideBar]="isEnterprise && displaySideBar"
    >
    <!--  [stopEditingWhenCellsLoseFocus]=true -->
  </ag-grid-angular>  
  @if (summaryRow != null) {
    @if (summaryRow == "numRows") {
        <div class="mt-2">
            Anzahl  Zeilen: {{_data?.rows?.length}}
        </div>
    }
    @else if (summaryRow == "numSel") {
        <div class="mt-2">
            Selektiert: {{getSelectedRowCount()}}
        </div>
    }
    @else if (summaryRow == "numRowsNumSel") {
        <div class="mt-2">
            Anzahl  Zeilen: {{_data?.rows?.length}}, Selektiert: {{getSelectedRowCount()}}
        </div>
    }    
  }
  @if (disabled) {
    <div class="grid-overlay"></div>
  }
</div>